(function (ws) {
    'use strict';

    ws.views.faqView = Backbone.View.extend({

        events: {
            'click a.tcs-panel-heading': 'togglePanel'
        },

        /**
         * Toggle FAQ panel
         * @param {event} e
         */
        togglePanel: function(e) {
            e.stopPropagation();
            var $panel = $(e.currentTarget).next('.tcs-panel-body');
            $panel.slideToggle(100);
        }

    });
})(westcon);
